import * as Effects from 'redux-saga/effects'
import {formatter} from '../../../../utils'
import {getListSubmit} from '../../apis/formAPIs'

const call: any = Effects.call
const takeLatest = Effects.takeLatest
const put = Effects.put

const initialState = {
  submitGrid: {
    totalRow: undefined,
    data: undefined,
  },
}

interface GETDATASUBMIT {
  type: 'GETDATASUBMIT'
  payload: any
}

interface SAVEDATASUBMIT {
  type: 'SAVEDATASUBMIT'
  payload: any
}

type ActionTypes = SAVEDATASUBMIT | GETDATASUBMIT

export const actions = {
  getDataGrid: (data: any) => ({type: 'GETDATASUBMIT', payload: data}),
  saveDataGrid: (data: any) => ({type: 'SAVEDATASUBMIT', payload: data}),
}

export const gridReducer = (state = initialState, action: ActionTypes) => {
  switch (action.type) {
    case 'GETDATASUBMIT':
      return state
    case 'SAVEDATASUBMIT':
      const gridState = JSON.parse(JSON.stringify(state))
      if (action.payload) {
        gridState.submitGrid.totalItems = action.payload.totalItems
        gridState.submitGrid.data = []
        action.payload.items.map((o: any) => {
          let obj = {
            id: o.id,
            refId: o.refId,
            sellingContractId: o.sellingContractId,
            groupDomainCode: o.groupDomainCode,
            customerName: o.customerName,
            contractCode: o.contractCode,
            contractOriginalCode: o.contractOriginalCode,
            contractNumber: o.contractNumber,
            quatationNumber: o?.quatationNumber,
            sumFee: o.sumfee,
            sumFeeName: formatter(o.sumfee, o.curencyFee) + ' ' + o.curencyFee,
            time: o.time,
            submitUser: o.submitUser,
            submidDate: o.submidDate,
            submitType: o.submitType,
            approveType: o.approveType,
            approvalStatus: o.approvalStatus,
            submitContent: o.submitContent,
            email: o.email,
            mobile: o.mobile,
            submitDate: o.submitDate,
            approvalStatusName: o.approvalStatusName,
            approvedDate: o.approvedDate,
            approvedName: o.approvedName,
            processDate: o.processDate,
            submitTypeName: o.submitTypeName,
            submitUserName: o.submitUserName,
            groupDomainName: o.groupDomainName,
            productCode: o.productCode,
          }
          gridState.submitGrid.data.push(obj)
        })
      }
      return gridState
    default:
      return state
  }
}

export function* saga() {
  yield takeLatest('GETDATASUBMIT', function* getDataSubmitSaga(action: any) {
    try {
      //@ts-ignore
      const response: any = yield call(getListSubmit, action.payload)
      if (response && !response.isError) {
        yield put(actions.saveDataGrid(response.data))
      }
    } catch (error) {
      return
    }
  })
}
